import { render, staticRenderFns } from "./FactoryMedia.vue?vue&type=template&id=47365e21&scoped=true"
import script from "./FactoryMedia.vue?vue&type=script&lang=js"
export * from "./FactoryMedia.vue?vue&type=script&lang=js"
import style0 from "./FactoryMedia.vue?vue&type=style&index=0&id=47365e21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47365e21",
  null
  
)

export default component.exports